import React from 'react';
import sortBy from 'lodash/sortBy';

export const resolveGraduateBooleanValues = node => ({
  ...node,
  data: {
    ...node.data,
    graduate_is_active: node.data.graduate_is_active === 'Yes' ? true : false,
    graduate_is_featured:
      node.data.graduate_is_featured === 'Yes' ? true : false,
    graduate_is_integration_practitioner:
      node.data.graduate_is_integration_practitioner === 'Yes' ? true : false,
  },
});

export const resolveGraduateProps = node => {
  const booleanValues = resolveGraduateBooleanValues(node);
  const { data } = node;
  const props = {
    bbsh_graduations:
      data?.graduate_bbsh_graduation_list?.map(n => n.bbsh_graduation) || [],
    bio: data.graduate_bio?.html,
    city: data.graduate_city,
    country: data.graduate_country,
    email_address: data.graduate_email_address,
    name: data.graduate_name,
    phone_numbers: data.graduate_phone_list?.map(n => n.phone_number),
    portraitFluid: data.graduate_portrait?.fluid,
    state: data.graduate_state,
    website: data.graduate_website?.url,
    skype: data.graduate_skype,
    uid: node.uid,
    ...data,
    ...booleanValues.data,
  };
  return props;
};

export const boolFilters = [
  {
    key: 'data.graduate_is_featured',
    label: 'Featured',
    indicator: (
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Group-2"
            transform="translate(-569.000000, -421.000000)"
            fill="#EFA822"
          >
            <path
              d="M577,421 C572.566265,421 569,424.581687 569,429 C569,433.419277 572.566265,437.000964 577,437.000964 C581.337349,437.000964 585,433.419277 585,429 C585,424.581687 581.337349,421 577,421 Z M570.542169,429 C570.542169,425.465542 573.433735,422.6 577,422.6 C580.46988,422.6 583.361446,425.465542 583.361446,429 C583.361446,432.535422 580.46988,435.400964 577,435.400964 C573.433735,435.400964 570.542169,432.535422 570.542169,429 Z M576.228916,425.247711 C576.421687,424.510361 577.481928,424.510361 577.674699,425.247711 L578.349398,427.116627 L580.277108,427.116627 C581.048193,427.116627 581.433735,428.108434 580.759036,428.564337 L579.216867,429.72 L579.795181,431.588916 C579.987952,432.326265 579.216867,432.939277 578.542169,432.483373 L577,431.328675 L575.361446,432.483373 C574.783133,432.939277 573.915663,432.326265 574.108434,431.588916 L574.783133,429.72 L573.144578,428.564337 C572.566265,428.108434 572.855422,427.116627 573.626506,427.116627 L575.554217,427.116627 L576.228916,425.247711 Z"
              id="icon-featured"
            ></path>
          </g>
        </g>
      </svg>
    ),
  },
  {
    key: 'data.graduate_is_integration_practitioner',
    label: 'Brennan Integration Practitioners',
    indicator: (
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Group-2"
            transform="translate(-591.000000, -421.000000)"
            fill="#D46C6D"
          >
            <path
              d="M598.903214,421 C595.806072,421 593.192859,423.471174 593.192859,426.519661 C593.192859,427.485385 593.483216,428.393281 593.870359,429.183594 L591.16036,433.045526 C590.966788,433.275873 590.966788,433.573686 591.063574,433.829092 C591.16036,434.083534 591.450717,434.257018 591.741074,434.28304 L593.870359,434.474836 L595.128573,436.595187 C595.225358,436.832281 595.515715,436.984561 595.709287,436.999018 C595.999644,437.012511 596.290001,436.886254 596.483572,436.663617 L599,433.124557 L601.516428,436.572056 C601.709999,436.794693 602.000356,436.921914 602.290713,436.907457 C602.484285,436.893964 602.774642,436.741684 602.871427,436.50459 L604.129641,434.384239 L606.258926,434.191479 C606.549283,434.165457 606.83964,433.992937 606.936426,433.738495 C607.033212,433.483089 607.033212,433.184312 606.83964,432.953965 L604.032855,429.011075 C604.419998,428.263169 604.61357,427.415992 604.61357,426.519661 C604.61357,423.471174 602.097142,421 598.903214,421 Z M603.064999,430.370991 C602.290713,431.131426 601.226071,431.677899 600.161428,431.912101 L602.097142,434.637717 L602.968213,433.252742 C603.064999,433.02625 603.25857,432.875898 603.548927,432.851803 L604.710355,432.746749 L603.064999,430.370991 Z M593.289645,432.837346 L594.935001,430.495321 C595.709287,431.232625 596.773929,431.751147 597.935357,431.949689 L595.902858,434.728314 L595.031787,433.343339 C594.935001,433.116847 594.74143,432.966494 594.451073,432.9424 L593.289645,432.837346 Z M594.838216,426.519661 C594.838216,424.342445 596.677144,422.576771 598.903214,422.576771 C601.226071,422.576771 602.968213,424.342445 602.968213,426.519661 C602.968213,428.696877 601.226071,430.462552 598.903214,430.462552 C596.677144,430.462552 594.838216,428.696877 594.838216,426.519661 Z M598.903214,424.942891 C598.032143,424.942891 597.257858,425.648389 597.257858,426.519661 C597.257858,427.390933 598.032143,428.096432 598.903214,428.096432 C599.871071,428.096432 600.548571,427.390933 600.548571,426.519661 C600.548571,425.648389 599.871071,424.942891 598.903214,424.942891 Z"
              id="icon-bip"
            ></path>
          </g>
        </g>
      </svg>
    ),
  },
  {
    key: 'data.graduate_is_active',
    label: 'Currently active',
    indicator: (
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
        <g
          id="icon-active"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <circle id="Oval" fill="#44C166" cx="8" cy="8" r="5"></circle>
        </g>
      </svg>
    ),
  },
];

export const sortGraduates = list => {
  return sortBy(list, [
    g => !g.data.graduate_is_featured,
    g => !g.data.graduate_is_integration_practitioner,
    g => !g.data.graduate_is_active,
    g => g.data.graduate_name,
  ]);
};
